import { axiosWithConfig } from '@assembly/config/axios'

export const getJobs = (page: number = 0, pageSize: number = 10) => {
  return axiosWithConfig.get(`/admin/jobs/all?page=${page}&pageSize=${pageSize}`)
}

export const createJob = (payload: any) => {
  // Ensure questionnaireFilters is properly formatted if present
  if (payload.questionnaireFilters) {
    // No need to modify - already an object structure
  }
  return axiosWithConfig.post(`/admin/jobs`, payload)
}

export const updateJob = (payload: any) => {
  // Ensure questionnaireFilters is properly formatted if present
  if (payload.questionnaireFilters) {
    // No need to modify - already an object structure
  }
  return axiosWithConfig.put(`/admin/jobs`, payload)
}

export const deleteJob = (id: string) => {
  return axiosWithConfig.delete(`/admin/jobs/${id}`)
}

export const searchJobs = (params: any, page: number = 0, pageSize: number = 10) => {
  // Add pagination parameters
  if (!(params instanceof URLSearchParams)) {
    params.page = page;
    params.pageSize = pageSize;
  } else {
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
  }

  return axiosWithConfig.post(`/admin/jobs/search`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  })
}